import { createReducer } from '@reduxjs/toolkit'
import { AUTH_ADD_ROLE, AUTH_ADD_USER, AUTH_DELETE_ROLE, AUTH_DELETE_USER, AUTH_GET_ROLES, AUTH_GET_USERS, AUTH_UPDATE_ROLE, AUTH_UPDATE_USER, CREATE_AUTHENICATOR } from './action';
import { Role, User } from 'src/types/auth';

export type MenuProps = {
    authenticator: any,
    users: User[];
    roles: Role[];
};

export const initialState: MenuProps = {
    authenticator: null,
    users: [],
    roles: [],
}
export default createReducer(initialState, (builder) =>
    builder
        .addCase(CREATE_AUTHENICATOR, (state, action) => {
            state.authenticator = action.payload.authenticator
        })
        // === USERS ===
        .addCase(AUTH_GET_USERS, (state, action) => {
            state.users = action.payload.users;
        })
        .addCase(AUTH_ADD_USER, (state, action) => {
            state.users.push(action.payload.user);
        })
        .addCase(AUTH_UPDATE_USER, (state, action) => {
            const updatedUser = action.payload.user;
            const index = state.users.findIndex((u) => u.id === updatedUser.id);
            if (index !== -1) state.users[index] = updatedUser;
        })
        .addCase(AUTH_DELETE_USER, (state, action) => {
            state.users = state.users.filter((u) => u.id !== action.payload.userId);
        })

        // === ROLES ===
        .addCase(AUTH_GET_ROLES, (state, action) => {
            state.roles = action.payload.roles;
        })
        .addCase(AUTH_ADD_ROLE, (state, action) => {
            state.roles.push(action.payload.role);
        })
        .addCase(AUTH_UPDATE_ROLE, (state, action) => {
            const updatedRole = action.payload.role;
            const index = state.roles.findIndex((u) => u.id === updatedRole.id);
            if (index !== -1) state.roles[index] = updatedRole;
        })
        .addCase(AUTH_DELETE_ROLE, (state, action) => {
            state.roles = state.roles.filter((r) => r.name !== action.payload.roleName);
        })

)